
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import ColunaGrade from '@/core/components/Tela/ColunaGrade.vue';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoRelatoriosVendas from '@/servicos/Relatorios/ServicoRelatoriosVendas';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import { IDadosRelatorioComissao, IDadosRelatorioComissaoItem } from '@/models/Relatorios/Venda/IDadosRelatorioComissao';
import SelecionarTipoComissao from '@/components/Vendas/SelecionarTipoComissao.vue';
import SelecionarStatusComissao from '@/components/Vendas/SelecionarStatusComissao.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import {
  ITituloFinanceiro, ITituloFinanceiroAnexo, ITituloFinanceiroCentroCusto, ITituloFinanceiroDetalhamento, ITituloFinanceiroDocumentoFiscal,
  ITituloFinanceiroMarcador,
  ITituloFinanceiroUsuarioRegistroAtividade,
} from '@/models/Entidades/Financeiro/TitulosFinanceiros/ITituloFinanceiro';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';
import { EDocumentoFiscal } from '@/core/models/Enumeradores/EDocumentoFiscal';
import { EStatusTituloFinanceiro } from '@/models/Enumeradores/Financeiro/EStatusTituloFinanceiro';
import ServicoVendas from '@/servicos/Vendas/ServicoVendas';
import { EStatusComissao } from '@/models/Enumeradores/Vendas/EStatusComissao';
import TotalizadorDecorado from '@/core/components/Tela/TotalizadorDecorado.vue';
import DadosContaPagar from '@/components/Financeiro/TitulosFinanceiros/DadosContaPagarModal.vue';
import { IParametrosComissao } from '@/models/ParametrosRequisicao/Vendas/IParametrosComissao';
import { IVendaComissao } from '@/models/Entidades/Vendas/IVenda';
import { IFiltrosRelatorioComissao } from '@/models/Relatorios/Venda/IFiltrosRelatorioComissao';
import SelecionarTipoDataComissao from '@/components/Vendas/SelecionarTipoDataComissao.vue';
import { ETipoRelatorioComissao } from '@/models/Enumeradores/Relatorios/ETipoRelatorioComissao';
import { IDevolucaoVendaComissao } from '@/models/Entidades/Vendas/IDevolucaoVenda';

export default defineComponent({
  name: 'AcertoComissaoVenda',
  components: {
    TituloPadrao,
    ColunaGrade,
    Icone,
    Card,
    SelecionarDataInicialFinal,
    SelecionarColaborador,
    PreviewPdf,
    SelecionarTipoComissao,
    SelecionarStatusComissao,
    TotalizadorDecorado,
    DadosContaPagar,
    SelecionarTipoDataComissao,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioVenda = new ServicoRelatoriosVendas();
    const servicoVenda = new ServicoVendas();
    const {
      telaBase, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta, apresentarMensagemErro,
      preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, defineEmpresasSelecionadasComPermissao,
      preencherDadosRota,
    } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const state = reactive({
      dataInicial: '01/01/2001',
      dataFinal: '10/01/2001',
      filtros: {} as IFiltrosRelatorioComissao,
      filtrosUtilizados: {} as IFiltrosRelatorioComissao,
      resultado: {} as IDadosRelatorioComissao,
      itens: [] as IDadosRelatorioComissaoItem[],
      paginacao: {} as IPagination,
      paginacaoAPI: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivoPdf: [] as IArquivoPdf[],
      mostrarFiltrosInteligentes: 1,
      mostrarFiltros: 0,
      codigoColaborador: 0,
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
      exibirContasPagar: false,
      operacaoLancamento: {} as ITelaOperacao,
      comissoesSelecionadas: [] as IDadosRelatorioComissaoItem[],
      tituloFinanceiro: {} as ITituloFinanceiro,
      totalSelecionado: 0,
      vendaComissao: {} as IParametrosComissao,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'Codigo', key: 'Item', position: 1, visible: false,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Codigo', dataIndex: 'codigoComissao', key: 'codigoComissao', position: 0, visible: false,
          },
          {
            title: 'Pedido', dataIndex: 'venda', key: 'Venda', position: 1, visible: true, align: 'right', width: 110,
          },
          {
            title: 'Nota', dataIndex: 'nota', key: 'Nota', position: 2, visible: true, align: 'right', width: 80,
          },
          {
            title: 'Cliente', dataIndex: 'nomeCliente', key: 'Cliente', position: 3, visible: true, align: 'center', width: 150,
          },
          {
            title: 'Colaborador', dataIndex: 'colaborador', key: 'Colaborador', position: 4, visible: true, align: 'left', width: 150,
          },
          {
            title: 'Data', dataIndex: 'dataVenda', key: 'DataVenda', position: 5, visible: true, align: 'center', width: 120, customRenderRow: ECustomRenderRow.MascararData,
          },
          {
            title: 'Data Vencimento', dataIndex: 'dataVencimento', key: 'DataVendaVencimento', position: 6, visible: true, align: 'center', width: 170, customRenderRow: ECustomRenderRow.MascararData,
          },
          {
            title: 'Valor', dataIndex: 'valorVenda', key: 'ValorVenda', position: 7, visible: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado, width: 130,
          },
          {
            title: 'Vlr Título', dataIndex: 'valorTitulo', key: 'ValorTitulo', position: 8, visible: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado, width: 130,
          },
          {
            title: '% Comissão', dataIndex: 'percentualComissao', key: 'PercentualComissao', position: 9, visible: true, align: 'right', customRenderRow: ECustomRenderRow.MascararPorcentagem, width: 130,
          },
          {
            title: 'Vlr Comissão', dataIndex: 'valorComissao', key: 'ValorComissao', position: 10, visible: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado, width: 130,
          },
          {
            title: 'Status Comissão', dataIndex: 'status', key: 'status', position: 11, visible: true, align: 'right', width: 170,
          },
          {
            title: 'Data da Baixa', dataIndex: 'dataBaixa', key: 'DataBaixa', position: 12, visible: true, align: 'center', width: 170, customRenderRow: ECustomRenderRow.MascararData,
          },
          {
            title: 'Recebido', dataIndex: 'valorRecebido', key: 'Recebido', position: 13, visible: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado, width: 130,
          },
          {
            title: 'Status Título', dataIndex: 'statusTitulo', key: 'statusTitulo', position: 14, visible: true, align: 'right', width: 130,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_COMISSAO_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.comissoesSelecionadas = [] as IDadosRelatorioComissaoItem[];
      gradeBase.codigosSelecionados = [];
      state.filtros.dataInicial = state.dataInicial;
      state.filtros.dataFinal = state.dataFinal;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.resultado = await servicoRelatorioVenda.obterComissao(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      state.itens = state.resultado.itens.dados;
      state.paginacaoAPI = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      telaBase.carregando = false;
    }

    async function gerarContasPagar() {
      if (!UtilitarioGeral.validaLista(state.comissoesSelecionadas)) {
        apresentarMensagemAlerta('Selecione ao menos uma comissão para gerar as contas a pagar.');
        return;
      }
      const vendaComissoes = [] as IVendaComissao[];
      const devolucaoComissoes = [] as IDevolucaoVendaComissao[];
      for (let i = 0; i < state.comissoesSelecionadas.length; i += 1) {
        if (state.comissoesSelecionadas[i].tipoComissao === 1) {
          const comissao = state.comissoesSelecionadas[i];
          const vendaComissao = {} as IVendaComissao;
          vendaComissao.codigoTituloFinanceiro = 0;
          vendaComissao.codigo = comissao.codigo;
          const titulo = {} as ITituloFinanceiro;
          titulo.valorTotal = comissao.valorComissao;
          titulo.saldo = comissao.valorComissao;
          titulo.observacoes = `Comissão Venda N° ${comissao.venda}`;
          titulo.codigoPessoa = comissao.codigoColaborador;
          titulo.numeroTitulo = `COM-${comissao.venda}`;
          titulo.status = EStatusTituloFinanceiro.Pendente;
          titulo.dataCompetencia = UtilitarioData.obterDataAtual();
          titulo.codigoTipoDocumentoFinanceiro = 0;
          titulo.tipo = ETipoTituloFinanceiro.Pagar;
          titulo.documentoFiscal = {} as ITituloFinanceiroDocumentoFiscal;
          titulo.centrosCusto = [] as ITituloFinanceiroCentroCusto[];
          titulo.detalhamentos = [] as ITituloFinanceiroDetalhamento[];
          titulo.marcadores = [] as ITituloFinanceiroMarcador[];
          titulo.anexos = [] as ITituloFinanceiroAnexo[];
          titulo.registrosAtividades = [] as ITituloFinanceiroUsuarioRegistroAtividade[];
          titulo.documentoFiscal.tipoDocumento = EDocumentoFiscal.NFe;
          titulo.documentoFiscal.origem = 1;
          titulo.codigoEmpresa = state.filtros.empresa;
          titulo.codigoConta = state.tituloFinanceiro.codigoConta;
          titulo.codigoPlanoContaCategoria = state.tituloFinanceiro.codigoPlanoContaCategoria;
          titulo.dataVencimento = state.tituloFinanceiro.dataVencimento;
          titulo.centrosCusto = state.tituloFinanceiro.centrosCusto;
          titulo.codigoTipoDocumentoFinanceiro = state.tituloFinanceiro.codigoTipoDocumentoFinanceiro;
          titulo.parcela = 1;
          vendaComissao.tituloFinanceiro = titulo;
          vendaComissoes.push(vendaComissao);
        } else {
          const comissao = state.comissoesSelecionadas[i];
          const devolucaoComissao = {} as IDevolucaoVendaComissao;
          devolucaoComissao.codigoTituloFinanceiro = 0;
          const titulo = {} as ITituloFinanceiro;
          devolucaoComissao.codigo = comissao.codigo;
          titulo.valorTotal = comissao.valorComissao;
          titulo.saldo = comissao.valorComissao;
          titulo.observacoes = `Comissão Devolução Venda N° ${comissao.venda}`;
          titulo.codigoPessoa = comissao.codigoColaborador;
          titulo.numeroTitulo = `COM-DEV-${comissao.venda}`;
          titulo.status = EStatusTituloFinanceiro.Pendente;
          titulo.dataCompetencia = UtilitarioData.obterDataAtual();
          titulo.codigoTipoDocumentoFinanceiro = 0;
          titulo.tipo = ETipoTituloFinanceiro.Pagar;
          titulo.documentoFiscal = {} as ITituloFinanceiroDocumentoFiscal;
          titulo.centrosCusto = [] as ITituloFinanceiroCentroCusto[];
          titulo.detalhamentos = [] as ITituloFinanceiroDetalhamento[];
          titulo.marcadores = [] as ITituloFinanceiroMarcador[];
          titulo.anexos = [] as ITituloFinanceiroAnexo[];
          titulo.registrosAtividades = [] as ITituloFinanceiroUsuarioRegistroAtividade[];
          titulo.documentoFiscal.tipoDocumento = EDocumentoFiscal.NFe;
          titulo.documentoFiscal.origem = 1;
          titulo.codigoEmpresa = state.filtros.empresa;
          titulo.codigoConta = state.tituloFinanceiro.codigoConta;
          titulo.codigoPlanoContaCategoria = state.tituloFinanceiro.codigoPlanoContaCategoria;
          titulo.dataVencimento = state.tituloFinanceiro.dataVencimento;
          titulo.centrosCusto = state.tituloFinanceiro.centrosCusto;
          titulo.codigoTipoDocumentoFinanceiro = state.tituloFinanceiro.codigoTipoDocumentoFinanceiro;
          titulo.parcela = 1;
          devolucaoComissao.tituloFinanceiro = titulo;
          devolucaoComissoes.push(devolucaoComissao);
        }
      }
      state.vendaComissao.vendaComissoes = vendaComissoes;
      state.vendaComissao.devolucaoComissoes = devolucaoComissoes;
      state.vendaComissao.empresa = state.filtros.empresa;
      const retorno = await servicoVenda.criarTitulosComissao(state.vendaComissao);
      if (retorno.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retorno.mensagem);
        return;
      }
      await buscarRelatorio();
    }

    async function gerarContaPagar() {
      if (!UtilitarioGeral.validaLista(state.comissoesSelecionadas)) {
        apresentarMensagemAlerta('Nenhuma comissão sem título gerado foi selecionada para gerar a conta a pagar.');
        gradeBase.codigosSelecionados = [];
        return;
      }
      if (state.totalSelecionado <= 0) {
        apresentarMensagemAlerta('O valor total das comissões selecionadas deve ser maior que zero para gerar a conta a pagar.');
        return;
      }
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Incluir;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = 0;
      state.operacaoLancamento.empresaSelecionada = state.filtros.empresa;
      state.tituloFinanceiro = {} as ITituloFinanceiro;
      state.tituloFinanceiro.documentoFiscal = {} as ITituloFinanceiroDocumentoFiscal;
      state.tituloFinanceiro.centrosCusto = [] as ITituloFinanceiroCentroCusto[];
      state.tituloFinanceiro.detalhamentos = [] as ITituloFinanceiroDetalhamento[];
      state.tituloFinanceiro.marcadores = [] as ITituloFinanceiroMarcador[];
      state.tituloFinanceiro.anexos = [] as ITituloFinanceiroAnexo[];
      state.tituloFinanceiro.registrosAtividades = [] as ITituloFinanceiroUsuarioRegistroAtividade[];
      state.tituloFinanceiro.codigoEmpresa = state.filtros.empresa;
      state.exibirContasPagar = true;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioVenda.obterArquivoComissao(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function obterDescricaoStatus(item: IDadosRelatorioComissaoItem): string {
      switch (item.status) {
        case EStatusComissao.Pendente:
          return 'Pendente';
        case EStatusComissao.Concluida:
          return 'Pago';
        case EStatusComissao.TituloGerado:
          return 'Parcial';
        case EStatusComissao.TituloRecebido:
          return 'Cancelado';
        default:
          return '';
      }
    }

    function obterDescricaoStatusFinanceiro(item: IDadosRelatorioComissaoItem):string {
      switch (item.statusTitulo) {
        case EStatusTituloFinanceiro.Pendente:
          return 'Pendente';
        case EStatusTituloFinanceiro.Baixado:
          return 'Baixado';
        case EStatusTituloFinanceiro.BaixadoParcialmente:
          return 'Baixado Parcialmente';
        case EStatusTituloFinanceiro.BaixadoCartao:
          return 'Baixado Cartao';
        case EStatusTituloFinanceiro.Renegociado:
          return 'Renegociado';
        case EStatusTituloFinanceiro.AprovacaoPendente:
          return 'Aprovacao Pendente';
        case EStatusTituloFinanceiro.Reprovado:
          return 'Reprovado';
        case EStatusTituloFinanceiro.Antecipado:
          return 'Antecipado';
        case EStatusTituloFinanceiro.Provisionado:
          return 'Provisionado';
        default:
          return 'Excluido';
      }
    }

    function limparFiltros() {
      state.filtros = {} as IFiltrosRelatorioComissao;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.tipo = ETipoRelatorioComissao.Recebimento;
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
      state.filtros.status = 5;
      state.filtros.codigoVendedor = 0;
      state.filtros.tipoData = 1;
    }

    function verificaAcoesComissaoSelecionados() {
      state.comissoesSelecionadas = [] as IDadosRelatorioComissaoItem[];
      state.totalSelecionado = 0;
      if (UtilitarioGeral.validaLista(gradeBase.codigosSelecionados)) {
        state.comissoesSelecionadas = state.itens.filter((c) => gradeBase.codigosSelecionados.includes(c.codigoComissao) && c.status === EStatusComissao.Pendente);
        state.comissoesSelecionadas.forEach((t) => {
          state.totalSelecionado += t.valorComissao;
        });
      }
    }

    const mudarSelecao = (selectedRowKeys: any) => {
      gradeBase.codigosSelecionados = selectedRowKeys;
      verificaAcoesComissaoSelecionados();
    };

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    function mostrarTotalPaginacao(total: number, range: number[]) {
      return `${UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${UtilitarioMascara.mascararNumeroInteiro(total)} registros`;
    }

    function keyupQuantidadeRegistroTotal(event: KeyboardEvent) {
      const alvo = event.target as HTMLInputElement | null;
      alterarQuantidadeRegistroTotal(alvo?.value ?? '');
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      // recuperarCache();
      preencherColunas();
      limparFiltros();
      buscarRelatorio();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      limparFiltros,
      obterIdentificadorCache,
      salvarCache,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      imprimir,
      alterarQuantidadeRegistroTotal,
      mostrarTotalPaginacao,
      keyupQuantidadeRegistroTotal,
      onPageChange,
      onShowSizeChange,
      gerarContaPagar,
      mudarSelecao,
      obterDescricaoStatus,
      gerarContasPagar,
      obterDescricaoStatusFinanceiro,
    };
  },
});
